import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex self-center border-[1.5px] border-solid rounded-md px-4 py-5 md:p-6 min-h-[96px] h-full shadow-md bg-white" }
const _hoisted_2 = { class: "flex flex-col w-full" }
const _hoisted_3 = {
  key: 0,
  class: "self-start mb-2"
}
const _hoisted_4 = {
  key: 1,
  class: "text-input-label uppercase"
}
const _hoisted_5 = {
  key: 2,
  class: "text-input-label pt-2"
}
const _hoisted_6 = { class: "flex mt-2" }
const _hoisted_7 = { class: "flex flex-col pr-3 w-fit max-w-1/2" }
const _hoisted_8 = { class: "flex items-end" }
const _hoisted_9 = {
  key: 0,
  class: "whitespace-normal break-words text-xl3-bold"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex flex-col pl-3 w-fit max-w-1/2 border-l-2 border-racq-white" }
const _hoisted_13 = { class: "flex items-end" }
const _hoisted_14 = {
  key: 0,
  class: "whitespace-normal break-words text-xl3-bold"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 4,
  class: "text-block text-m-brand mr-6"
}
const _hoisted_19 = { class: "flex pt-3 gap-4 mt-auto flex-wrap" }
const _hoisted_20 = ["aria-label"]
const _hoisted_21 = ["aria-label"]

import { RichText, Image, Link } from '@sitecore-jss/sitecore-jss-vue';
import { computed } from 'vue';
import { IPromoCardBasic } from '@/interfaces/entities/promo-card-basic.interface';
import { ButtonStyle } from '@/enums/button-style.enum';
import { mapFieldToEnum } from '@/mappers/sc-field-to-enum.mapper';
import RichTextWithModal from '@/components/RichTextWithModal/RichTextWithModal.vue';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'PromoCardBasic',
  props: {
    icon: {},
    title: {},
    subTitle: {},
    description: {},
    leftButtonLink: {},
    leftButtonStyle: {},
    leftButtonLabel: {},
    rightButtonLink: {},
    rightButtonStyle: {},
    rightButtonLabel: {},
    includeBankContent: {},
    leftMainLabel: {},
    leftMainLabelSuffix: {},
    leftSubLabel: {},
    rightMainLabel: {},
    rightMainLabelSuffix: {},
    rightSubLabel: {},
    footerText: {},
    dataTestId: {},
    openModalContent: {}
  },
  setup(__props: any) {

const props = __props;

const hasIcon = computed(() => !!props.icon?.value?.src);
const leftButtonStyle = computed<ButtonStyle | undefined>(() => mapFieldToEnum(ButtonStyle, props.leftButtonStyle));
const rightButtonStyle = computed<ButtonStyle | undefined>(() => mapFieldToEnum(ButtonStyle, props.rightButtonStyle));
const includeBankContent = computed(() => props.includeBankContent?.value);
const leftButtonClass = computed(() => [getButtonStyleClass(leftButtonStyle.value)]);
const rightButtonClass = computed(() => [getButtonStyleClass(rightButtonStyle.value)]);

const getButtonStyleClass = (buttonStyle: ButtonStyle | undefined) => {
  switch (buttonStyle) {
    case ButtonStyle.PRIMARY:
      return 'btn-primary';
    case ButtonStyle.SECONDARY:
      return 'btn-secondary';
    case ButtonStyle.TERTIARY:
      return 'btn-tertiary';
    default:
      return '';
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (hasIcon.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(Image), {
              media: _ctx.icon,
              class: "min-w-4 max-w-14"
            }, null, 8, ["media"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.title?.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(RichText), {
              field: _ctx.title,
              class: "group-active:text-racq-navy group-active:underline"
            }, null, 8, ["field"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.subTitle?.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(RichText), {
              field: _ctx.subTitle,
              class: "group-active:text-racq-navy group-active:underline"
            }, null, 8, ["field"])
          ]))
        : _createCommentVNode("", true),
      (includeBankContent.value)
        ? _renderSlot(_ctx.$slots, "bankContent", { key: 3 }, () => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.leftMainLabel?.value || _ctx.$slots.leftMainLabel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _renderSlot(_ctx.$slots, "leftMainLabel", {}, () => [
                          _createVNode(_unref(RichText), { field: _ctx.leftMainLabel }, null, 8, ["field"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.leftMainLabelSuffix?.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createVNode(_unref(RichText), {
                          field: _ctx.leftMainLabelSuffix,
                          class: "text-base-bold"
                        }, null, 8, ["field"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.leftSubLabel?.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_unref(RichText), {
                        field: _ctx.leftSubLabel,
                        class: "text-m-bold"
                      }, null, 8, ["field"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.rightMainLabel?.value || _ctx.$slots.rightMainLabel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _renderSlot(_ctx.$slots, "rightMainLabel", {}, () => [
                          _createVNode(_unref(RichText), { field: _ctx.rightMainLabel }, null, 8, ["field"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.rightMainLabelSuffix?.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _createVNode(_unref(RichText), {
                          field: _ctx.rightMainLabelSuffix,
                          class: "text-base-bold"
                        }, null, 8, ["field"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.rightSubLabel?.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_unref(RichText), {
                        field: _ctx.rightSubLabel,
                        class: "text-m-bold"
                      }, null, 8, ["field"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.footerText?.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(RichTextWithModal, {
                    field: _ctx.footerText,
                    modalContentHtml: _ctx.openModalContent,
                    class: "text-xs mt-3 mb-2"
                  }, null, 8, ["field", "modalContentHtml"])
                ]))
              : _createCommentVNode("", true)
          ])
        : _createCommentVNode("", true),
      (_ctx.description?.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_unref(RichText), {
              field: _ctx.description,
              class: "group-active:text-racq-med-grey group-active:no-underline"
            }, null, 8, ["field"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        (_ctx.leftButtonLabel?.value)
          ? (_openBlock(), _createBlock(_unref(Link), {
              key: 0,
              field: _ctx.leftButtonLink,
              class: "self-center min-w-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(`btn btn-md md:btn-sm ${leftButtonClass.value} text-left whitespace-normal break-words !h-auto !leading-[1rem]`),
                  "aria-label": _ctx.leftButtonLabel?.value
                }, _toDisplayString(_ctx.leftButtonLabel?.value), 11, _hoisted_20)
              ]),
              _: 1
            }, 8, ["field"]))
          : _createCommentVNode("", true),
        (_ctx.rightButtonLabel?.value)
          ? (_openBlock(), _createBlock(_unref(Link), {
              key: 1,
              field: _ctx.rightButtonLink,
              class: "self-center min-w-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(`btn btn-md md:btn-sm ${rightButtonClass.value} text-left whitespace-normal break-words !h-auto !leading-[1rem]`),
                  "aria-label": _ctx.rightButtonLabel?.value
                }, _toDisplayString(_ctx.rightButtonLabel?.value), 11, _hoisted_21)
              ]),
              _: 1
            }, 8, ["field"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})